import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { KeycloakService } from "keycloak-angular";

@Component({
  selector: "app-digital-identity",
  templateUrl: "./digital-identity.component.html",
  styleUrls: ["./digital-identity.component.scss"],
})
export class DigitalIdentityComponent {
  constructor(
    private router: Router,
    private keycloakService: KeycloakService
  ) {}

  user = "";
  isLoggedIn = false;
  async ngOnInit() {
    const userInfo = await this.keycloakService.loadUserProfile();
    this.user = userInfo?.username || null;
    this.isLoggedIn = await this.keycloakService.isLoggedIn();
  }

  async loginOrLogout() {
    if (this.isLoggedIn) {
      await this.keycloakService.logout();
    } else {
      await this.keycloakService.login({
        redirectUri: "https://ztaas.eastus.cloudapp.azure.com:4650",
      });
    }
  }

  openTools() {
    this.router.navigate(["digital-identity/auth-tools"]);
  }

  navigateToHome() {
    this.router.navigate(["/"]).then(() => {
      setTimeout(() => {
        const contactSection = document.getElementById("contact");
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 500); // Delay to ensure page loads before scrolling
    });
  }


}
